module.exports = __webpack_public_path__ + "img/temImage.985f4380.png";